import { getObjectUtil } from 'packages/src'
import { NETWORK_REQUEST_PATH } from '../../constants'

function getPathNetworkUtil (request) {
  return (
    getObjectUtil(request, NETWORK_REQUEST_PATH.ACTION_OLD_PATH) ||
    getObjectUtil(request, NETWORK_REQUEST_PATH.ACTION_PATH) ||
    getObjectUtil(request, NETWORK_REQUEST_PATH.ACTION_DOMAIN_LIST_PATH)
  )
}

export { getPathNetworkUtil }
